import { Dialog, Image } from "@onmo/ui";
import {
  InventoryAvatarData,
  InventoryBundleData,
} from "@onmo/graphql/graphql";
import Avatar from "../../core/Avatar/Avatar";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { removePopupQueue } from "../../../slices/popup";
import { PopupType } from "../../../constants/popup";
import { setSelectedInventory } from "../../../slices/shop";
import { useApplyInventory } from "../../../hooks/resolvers/useShopMutation";
import { useTranslation } from "react-i18next";

const PurchaseSuccessPopup: React.FC = (props) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { currentPopupId } = useAppSelector((state) => state.popup);
  const { selectedInventory, openBundle } = useAppSelector(
    (state) => state.shop,
  );
  const applyInventory = useApplyInventory(selectedInventory);

  const onClickClose = () => {
    dispatch(removePopupQueue({ type: PopupType.PurchaseResult }));
    dispatch(setSelectedInventory({ selectedInventory: undefined }));
  };

  const onClickMainAction = () => {
    if (selectedInventory) {
      applyInventory();
    }
    onClickClose();
  };

  return (
    <Dialog
      open={currentPopupId === PopupType.PurchaseResult}
      mainAction={{
        text: selectedInventory ? t("equip") : t("view"),
        onClick: onClickMainAction,
      }}
      secondAction={{
        text: t("close"),
        onClick: onClickClose,
      }}
      icon={
        selectedInventory ? (
          <Avatar
            size="xl"
            url={(selectedInventory?.data as InventoryAvatarData)?.url}
          />
        ) : (
          <Image
            src={(openBundle?.data as InventoryBundleData)?.previewUrl}
            width={100}
            height={100}
            radius={10}
          />
        )
      }
      title={t("purchase_successful")}
      description={t("view_your_new_avatar")}
    />
  );
};
export default PurchaseSuccessPopup;
